import Reducers from "./reducers";
import { createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import throttle from "lodash/throttle";
import { BaseChannel } from '../base/env';

const name = "garajmall";

const load_state = () => {
  try {
    try {
      localStorage.removeItem(`${name}_channelBootstrapped`);
    } catch (_) {
      /* legacy key could block bootstrap if set without updating Hig */
    }

    const serialized_state = localStorage.getItem(`${name}`);
    if (serialized_state === null) {
      return undefined;
    }

    const state = JSON.parse(serialized_state);
    let bootstrapJustRan = false;

    if (state?.Login && state.Login.channelBootstrapDone !== true) {
      state.Login.channel = BaseChannel;
      state.Login.pendingChannel = '';
      state.Login.channelBootstrapDone = true;
      bootstrapJustRan = true;
      try {
        localStorage.setItem(`${name}`, JSON.stringify(state));
      } catch (_) {
        /* ignore quota / private mode */
      }
    }

    // Backward compat: if channel exists but channelClaimed is missing, treat as claimed
    if (state?.Login?.channel && state.Login.channelClaimed === undefined) {
      state.Login.channelClaimed = true;
    }
    if (state?.Login && state.Login.pendingCid === undefined) {
      state.Login.pendingCid = '';
    }

    if (state?.Login) {
      const params =
        typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;

      const urlChannel = params?.get('channel');
      const flow = params?.get('flow');

      const shouldApplyDirect = flow === 'direct';

      if (shouldApplyDirect && urlChannel && state.Login.channel !== urlChannel) {
        state.Cart = [];
        state.Login.channel = urlChannel;
        state.Login.cart_data = {
          total_amount: 0,
          total_quantity: 0,
          payable_amount: 0,
          discount_amount: 0,
          total_usable_credit: 0,
          tax_amount: 0,
          wallet_amount: 0
        };
      }
    }

    if (bootstrapJustRan) {
      try {
        localStorage.setItem(`${name}`, JSON.stringify(state));
      } catch (_) {
        /* ignore quota / private mode */
      }
    }

    return state;
  } catch (e) {
    console.log('Load State Error : ', e);
    return undefined;
  }
};

const save_state = (state) => {
  try {
    const serialized_state = JSON.stringify(state);
    localStorage.setItem(`${name}`, serialized_state);
  } catch (e) {
    console.log('Save State Error : ', e);
    return undefined;
  }
};

// Redux Middleware
const persisted_state = load_state();
const store = createStore(Reducers, persisted_state, composeWithDevTools());
store.subscribe(
  throttle(() => {
    const state = store.getState();

    save_state({
      Cart: state.Cart,
      Login: {
        ...state.Login,
        pendingChannel: state.Login.pendingChannel,
        pendingCpid: state.Login.pendingCpid,
        pendingCid: state.Login.pendingCid
      },
      Region: state.Region,
      Category: state.Category
    });
  }, 1000)
);

export default store;
